import styled from 'styled-components';

import { Container } from '@components/ions/layouts';
import { Card } from '@components/molecules/Card/Card';

export const ButtonsWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin-bottom: 12px;
`;

export const LoginCard = styled(Card)`
    height: 100%;
`;

export const LoginMessagingContainer = styled(Container)`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
`;
